import { defineStore } from 'pinia'
import axios from 'axios'
import { ref } from 'vue'

const strapiUrl = import.meta.env.VITE_STRAPI_URL

export const useCmsStore = defineStore('cmsStore', () => {
  const productionTip = ref({})

  const getProductionTipByLocale = async (activeLocale) => {
    const res = await axios.get(
      `${strapiUrl}/api/account-artworks?locale=${activeLocale}&populate[0]=Image&pagination[limit]=100`
    )
    const randomProductTip =
      res.data.data[Math.floor(Math.random() * res.data.data.length)].attributes
    Object.assign(productionTip.value, randomProductTip)
  }

  return {
    productionTip,
    getProductionTipByLocale
  }
})
